/* eslint-disable import/prefer-default-export */
import PanicError from 'Errors/Panic';

export { pathMatches } from 'Components/ClientApp/CombinedApp/Navigation/pathMatches';

export const isHidden = (args) => {
  return (schemaItem) => {
    if (!schemaItem.hidden) {
      return true;
    }
    switch (typeof schemaItem.hidden) {
      case 'function':
        return !schemaItem.hidden(args);

      default:
        return !schemaItem.hidden;
    }
  };
};

export const checkDisabled = (schemaItem, args) => {
  const { disabled } = schemaItem;

  // By default this should not be disabled
  if (!disabled) {
    return false;
  }

  switch (typeof disabled) {
    case 'function':
      return disabled(args);
    case 'boolean':
      return disabled;
    default:
      throw new PanicError('unexpected-type', '\'disabled\' must be one of function or boolean if specified.', {
        disabledType: typeof disabled,
      });
  }
};

export const getSelectedItem = (schema) => {
  const defaultSelection = schema.navigationItems.find(v => v.defaultSelection);

  if (!defaultSelection) {
    throw new PanicError('default-selection-required', 'An item from the bottom menu must be the default selection');
  }

  const selection = schema.navigationItems
    .filter(v => v.isSelected)
    .find(v => v.isSelected(window));

  if (selection) {
    return selection;
  }

  return defaultSelection;
};
